<template>
    <div class="text-center pt-1 mb-5 pb-1">

        <slot name="buttons"></slot>
    </div>
</template>

<script setup>

</script>

<style lang="css">

</style>